import { ref } from 'vue';

const oimAppointment = () => {
    const oimAppointment_error = ref(null);
    const oimAppointments = ref(null);

    const loadOimAppointment = async ( monitor_others, view_locations) => {
        var params = [];
        params.push(['monitor_others',monitor_others]);
        params.push(['view_locations', view_locations]);
        
        try {
            let data = await fetch("/api/oimappointments?" + new URLSearchParams(params));

            //console.log("data oimapp: " ,data);
            if (!data.ok) {
                throw Error("Can't load data");
            }

            oimAppointments.value = await data.json();

            // console.log("oimApp: " , oimAppointments.value);
        } catch (err) {
            oimAppointment_error.value = err.message;
        }
    };

    return { oimAppointments, oimAppointment_error, loadOimAppointment };
}

export default oimAppointment;
